class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.setHeaderCartIconAccessibility();
		//this.addCloseButtonHandlers();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});
		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	addCloseButtonHandlers() {
		const detailsElement = this.querySelector('#Details-CartDrawer');
		const closeButton = this.querySelector('#cart_note-close');
		const applyButton = this.querySelector('#apply_button');

		if (detailsElement && closeButton && applyButton) {
			function closeDetails(event) {
				detailsElement.removeAttribute('open');
			}

			closeButton.addEventListener('click', closeDetails);
			applyButton.addEventListener('click', closeDetails);
		}
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add("animate", "active");
			this.addCloseButtonHandlers();
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("overflow-hidden");
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

renderContents(parsedState) {
  this.querySelector(".drawer__inner").classList.contains("is-empty") &&
    this.querySelector(".drawer__inner").classList.remove("is-empty");
  this.productId = parsedState.id;

  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    sectionElement.innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

setTimeout(() => {
  const overlay = this.querySelector("#CartDrawer-Overlay");
  if (overlay) {
    overlay.addEventListener("click", this.close.bind(this));
  }

  const toastCard = document.getElementById("cart-toast-card");
  const viewCartBtn = document.getElementById("cart-toast-view-cart");
  const toastImageWrap = document.getElementById("cart-toast-image-wrap");
  const toastTitle = document.getElementById("cart-toast-title");
  const toastPrice = document.getElementById("cart-toast-price");

  if (viewCartBtn && toastCard) {
    viewCartBtn.onclick = (e) => {
      e.preventDefault();
      toastCard.classList.remove("show");
      this.open(document.querySelector("#cart-icon-bubble"));
    };
  }

  if (!toastCard || !toastImageWrap || !toastTitle || !toastPrice) return;

  const lastInfo = window.lastAddedProductInfo || {};

  toastImageWrap.innerHTML = '<img id="cart-toast-image" src="" alt="" class="cart-toast-card__image">';
  let activeToastImage = document.getElementById("cart-toast-image");

  if (!activeToastImage) return;

  activeToastImage.src = "";
  activeToastImage.alt = "";
  activeToastImage.style.display = "block";
  activeToastImage.classList.remove("is-loaded");

  toastTitle.textContent = "";
  toastPrice.textContent = "";

  let imageAssigned = false;
  let toastShown = false;

  function showToast() {
    if (toastShown) return;
    toastShown = true;

    toastCard.classList.add("show");

    clearTimeout(toastCard._timer);
    toastCard._timer = setTimeout(() => {
      toastCard.classList.remove("show");
    }, 4888);
  }

  function bindImageEvents(imgEl) {
    imgEl.onload = function () {
      this.style.display = "block";
      this.classList.add("is-loaded");
      showToast();
    };

    imgEl.onerror = function () {
      this.style.display = "none";
      showToast();
    };
  }

  function setToastImage(src, altText = "Product image") {
    if (!src || src.startsWith("data:")) return false;

    bindImageEvents(activeToastImage);
    activeToastImage.src = src;
    activeToastImage.alt = altText;
    return true;
  }

  if (lastInfo.imageNode && toastImageWrap) {
    const clonedImg = lastInfo.imageNode.cloneNode(true);
    clonedImg.id = "cart-toast-image";
    clonedImg.className = "cart-toast-card__image";
    clonedImg.removeAttribute("sizes");
    clonedImg.removeAttribute("loading");
    clonedImg.setAttribute("decoding", "async");
    clonedImg.setAttribute("fetchpriority", "high");

    const preferredSrc = lastInfo.image || getBestImageSrc(clonedImg);
    if (preferredSrc) {
      clonedImg.src = preferredSrc;
    }

    if (!lastInfo.isFindterImage) {
      clonedImg.removeAttribute("srcset");
    }

    bindImageEvents(clonedImg);

    toastImageWrap.innerHTML = "";
    toastImageWrap.appendChild(clonedImg);
    activeToastImage = clonedImg;
    imageAssigned = true;

    if (clonedImg.complete && clonedImg.naturalWidth > 0) {
      clonedImg.classList.add("is-loaded");
      showToast();
    } else {
      setTimeout(() => {
        showToast();
      }, 220);
    }
  } else if (lastInfo.image && !lastInfo.image.startsWith("data:")) {
    imageAssigned = setToastImage(lastInfo.image, lastInfo.title || "Product image");

    setTimeout(() => {
      showToast();
    }, 220);
  }

  const cleanLastTitle = (lastInfo.title || "").trim();

if (
  cleanLastTitle &&
  cleanLastTitle !== "+" &&
  cleanLastTitle.toLowerCase() !== "add to cart" &&
  cleanLastTitle.toLowerCase() !== "quick add"
) {
  toastTitle.textContent = cleanLastTitle;
}

  if (lastInfo.price && lastInfo.price.toLowerCase() !== "regular price") {
    toastPrice.textContent = lastInfo.price;
  }

  const drawerItems = document.querySelectorAll("#CartDrawer .cart-item");
  let matchedItem = null;

  if (lastInfo.variantId && drawerItems.length) {
    drawerItems.forEach((item) => {
      const itemId =
        item.dataset.variantId ||
        item.getAttribute("data-variant-id") ||
        "";

      const removeLink = item.querySelector('a[href*="variant="]');
      let variantFromLink = "";

      if (removeLink) {
        try {
          variantFromLink = new URL(
            removeLink.href,
            window.location.origin
          ).searchParams.get("variant") || "";
        } catch (e) {}
      }

      if (
        String(itemId) === String(lastInfo.variantId) ||
        String(variantFromLink) === String(lastInfo.variantId)
      ) {
        matchedItem = item;
      }
    });
  }

  if (!matchedItem && drawerItems.length) {
    matchedItem = drawerItems[0];
  }

  if (matchedItem) {
    if (!imageAssigned) {
      const matchedImage = matchedItem.querySelector("img");
      if (matchedImage) {
        const fallbackSrc =
          matchedImage.currentSrc ||
          matchedImage.getAttribute("src") ||
          matchedImage.getAttribute("data-src") ||
          "";

        if (fallbackSrc) {
          imageAssigned = setToastImage(
            fallbackSrc,
            matchedImage.alt || "Product image"
          );
        }
      }
    }

    if (!toastTitle.textContent) {
      const matchedTitle = matchedItem.querySelector(
        '.cart-item__details a[href*="/products/"], .cart-item__name, .cart-item__title'
      );
      if (matchedTitle) {
        toastTitle.textContent = matchedTitle.textContent.trim();
      }
    }

    if (!toastPrice.textContent) {
      const matchedPrice =
        matchedItem.querySelector(".price-item--final") ||
        matchedItem.querySelector(".price-item--sale") ||
        matchedItem.querySelector(".price .money") ||
        matchedItem.querySelector(".cart-item__price") ||
        matchedItem.querySelector(".price-item--regular");

      if (matchedPrice) {
        const priceText = matchedPrice.textContent.trim();
        if (priceText && priceText.toLowerCase() !== "regular price") {
          toastPrice.textContent = priceText;
        }
      }
    }
  }

  if (!imageAssigned) {
    showToast();
  }
});
}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);
